import {devConfig} from './dev';
import {prodConfig} from './prod';
import {testConfig} from './test';

import {DEV, PROD, TEST} from '../constants';

/***
 * @function getConfigForEnv
 * @description gets the default config values for the process.env
 */
export const getConfigForEnv = () => {
	const configEnv = process.env.NODE_ENV ? process.env.NODE_ENV : PROD;
	if (configEnv === PROD) return prodConfig;

	if (configEnv === DEV) return {...prodConfig, ...devConfig};

	if (configEnv === TEST) return {...prodConfig, ...testConfig};

	return {};
};
